import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MailPrefetch" */ './lazyIndex')
);

export { TableView };

// Delay actions
export let lazyPrefetchItem = new LazyAction(lazyModule, m => m.prefetchSingleItem);
export let lazyPrefetchFirstN = new LazyAction(lazyModule, m => m.prefetchFirstN);
export let lazyPrefetchAdjacentItemsOnDelay = new LazyAction(
    lazyModule,
    m => m.prefetchAdjacentItemsOnDelay
);
